<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>{{title}}<button type="button" class="close"
                           @click.prevent="closeModal()">
        <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <div class="container-fluid">
      <div class="row justify-content-center m-2">
        <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
          <div>{{ generalErrorMessage }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-5"></div>
        <div class="col-10 text-right">
          <b-form-group id="surveyFieldGroup"
                        :label-cols="5"
                        label="Survey Set"
                        label-for="surveyField"
                        :state="stateForField('survey')"
                        :invalid-feedback="errorForField('survey')">
            <b-form-select id="surveyFieldId" v-model="chosenSurveySetId" :options="surveyOptions" :text="surveys.name" @click.prevent="setSurvey(survey.organizationSurveySetId)"/>
          </b-form-group>
          <b-form-group id="emailFieldGroup"
                        class="text-left"
                        :label-cols="5">
          <b-form-checkbox v-model="sendEmail" :disabled="!email" switch>
            <span>Email<span v-show="email.length > 0"> to {{ email }}</span></span>
          </b-form-checkbox>
          </b-form-group>
          <b-form-group id="smsFieldGroup"
                        class="text-left"
                        :label-cols="5">
          <b-form-checkbox v-model="sendText" :disabled="!phoneNumber" switch>
            <span>SMS/Text<span v-show="phoneNumber.length > 0"> to {{ phoneNumber }}</span></span>
          </b-form-checkbox>
          </b-form-group>
        </div>
      </div>
    </div>

    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange m-1 wide-button float-right" @click.prevent="sendSurvey()">
        <i v-if="isSaving" class="fa fa-spinner fa-spin"></i> Send
      </button>
      <button type="button" class="btn btn-outline-orange m-1 wide-button float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>
<script>
  import api from '@/services/api'
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'
  export default {
    name: 'PatientSurveyModal',

    mixins: [ErrorsMixin, AnalyticsMixin],

    data () {
      return {
        isLoading: true,
        surveys: [],
        isSaving: false,
        chosenSurveySetId: 0,
        sendEmail: true,
        sendText: true
      }
    },

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      title: {
        type: String,
        default: 'Send Patient Health Survey'
      },

      id: {
        type: Number,
        required: true
      },
      patient: {
        type: Object,
        required: true
      }
    },

    watch: {
      visible (newValue) {
        this.chosenSurveySetId = 0
      },
      patient (newValue, oldValue) {
        if (newValue && this) {
          const email = this.email
          this.sendEmail = (email.length > 0)

          const phone = this.phoneNumber
          this.sendText = (phone.length > 0)
        }
      }
    },

    computed: {
      surveyOptions () {
        const options = [{ value: 0, text: 'Click to select' }]
        this.surveys.forEach(survey => {
          options.push({ value: survey.organizationSurveySetId, text: survey.name })
        })
        return options
      },
      email () {
        let em = ''

        if (this.patient) {
          if (this.patient.email) {
            em = (this.patient.email === '() -') ? '' : this.patient.email
          }
        }

        return em
      },

      phoneNumber () {
        let phone = ''

        if (this.patient) {
          if (this.patient.phoneNumber) {
            phone = (this.patient.phoneNumber === '() -') ? '' : this.patient.phoneNumber
          }
        }

        return phone
      }
    },

    methods: {
      closeModal () {
        this.clearAllErrors()
        this.$emit('update:visible', false)
      },
      validate () {
        this.clearAllErrors()
        if (this.chosenSurveySetId === 0) {
          this.addErrorForField('survey', 'Please select a survey')
        }
        return !this.hasErrors()
      },
      loadData () {
        this.isLoading = true

        api.get('/Dashboard/SurveySets').then(response => {

          this.surveys = response.data
        }).catch(error => {
          this.isLoading = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.trackEvent(this.$options.name, 'GetSurvey', error)
          }
        })
      },
      sendSurvey () {
        if (!this.validate()) {
          return
        }
        if (this.isSaving === true) {
          return
        }
        const parameters = {
          sendEmail: this.sendEmail,
          sendText: this.sendText
        }
        this.isSaving = true
        api.post('/Dashboard/Patient/' + this.id + '/SendOrgSurveySet/' + this.chosenSurveySetId, parameters).then(response => {
          this.isSaving = false
          this.$emit('surveySent')
        }).catch(error => {
          this.isSaving = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.trackEvent(this.$options.name, 'SendSurvey', error)
          }
        })
      },

      setSurvey (surveySetId) {
        this.chosenSurveySetId = surveySetId
      }
    },

    created () {
      this.loadData()
    }
  }
</script>
